import { render, staticRenderFns } from "./indexHome.vue?vue&type=template&id=ddbab0dc&scoped=true&"
import script from "./indexHome.vue?vue&type=script&lang=js&"
export * from "./indexHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbab0dc",
  null
  
)

export default component.exports